import {
  type TephigramToolCreateFormData,
  TephigramToolUpdateForm,
} from "@/overlay/components/SmartForm/ToolsForms/TephigramForm/TephigramToolUpdateForm";
import { useAppDispatch } from "@/reducer";
import { updateTephigramState } from "@/reducer/TephigramState";
import type { TephigramSchemaOutput } from "@mm/metx-workbench.meteomatics.com";
import type { SubmitHandler } from "react-hook-form";

type TephigramToolUpdateControllerProp = {
  tephigram: TephigramSchemaOutput;
};

/**
 * Handles all the logic for tehpigram update.
 * Note:
 * This is a controller, meaning that we should generally NOT delegate tool/layer creation logic
 * to the parent component by passing callback from parent etc.
 */
export function TephigramToolUpdateController(props: TephigramToolUpdateControllerProp) {
  const dispatch = useAppDispatch();

  const onSubmit: SubmitHandler<TephigramToolCreateFormData> = (formData) => {
    dispatch(updateTephigramState({ id: props.tephigram.id, tephigram: formData.layerData }));
  };

  return <TephigramToolUpdateForm defaultFormData={props.tephigram} onSubmit={onSubmit} submitMode="onChange" />;
}
